import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import autoBind from "react-autobind";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

import * as playerActions from "../../actions/playerActions";

import ToggleMiraSpeaking from "../shared/button/ToggleMiraSpeaking";

import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";

//Placeholder
class ActivityPlayerShowModeToolbar extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	onClickPlay() {
		if (this.props.onClickPlay) {
			this.props.onClickPlay();
		}	
	}

	onClickComments() {
		if (this.props.onClickComments) {
			this.props.onClickComments();
		}	
	}

	onClickClose() {
		const currentActivity = this.context.tree.get(["activity"]);

		if (currentActivity.allowSwitchToShowMode) {
			this.props.dispatch(playerActions.hideShowMode);
		} else {
			if (this.props.onClickClose) {
				this.props.onClickClose();
			}
		}

	}

	render() {	
		const currentActivity = this.context.tree.get(["activity"]);

		let playButton = (this.props.showPlayButton) ? <div className="player-show-mode-toolbar-button" style={{marginRight: "8px"}} onClick={this.onClickPlay}>
			<FontAwesomeIcon icon="play-circle" />
		</div> : null;

		let showExitButton = true;
		if (this.props.persistenceType.toLowerCase() === "default" && this.props.navStack.length === 0 && !currentActivity.allowSwitchToShowMode) {
			showExitButton = false;
		}

		return (
			<div className="player-show-mode-toolbar-container">
				<div style={{ display: "flex", flexDirection: "row" }}>
					{playButton}
					{this.props.showComments &&
					<div className="player-show-mode-toolbar-button" onClick={this.onClickComments}>
						<FontAwesomeIcon icon="file-text" />
					</div>
					}
					<ToggleMiraSpeaking size={32} onPress={() => { 
							if (SyntheticVoiceApi.isSpeaking()) {
								SyntheticVoiceApi.stop();
								this.context.tree.set(["miraSpeaking"], false);
							} else {
								console.log("Tap speak selected item");
								playerActions.speakSelectedItem(this.context.tree); 
							}
 						}} />
				</div>		
	
				<div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
					{showExitButton && <div className="player-show-mode-toolbar-close-button" onClick={this.onClickClose}>
						<FontAwesomeIcon icon="window-close" />
					</div>}
				</div>
			</div>
		);
	}
}

ActivityPlayerShowModeToolbar.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	user: ["user"],
	persistenceType: ["appState","targetConfig","type"],
	miraSpeaking: ["miraSpeaking"],
	navStack: ["player", "navStack"]
}, ActivityPlayerShowModeToolbar);